import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormControl, AbstractControl } from '@angular/forms';
import { SendSmsService } from 'src/app/domains/sales/send-sms/services/send-sms.service';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';

@Component({
  selector: 'gdp-send-sms',
  templateUrl: './send-sms.component.html',
  styleUrls: ['./send-sms.component.scss']
})
export class SendSmsComponent implements OnInit {

  sendSmsForm: UntypedFormGroup;
  loading: boolean = false;

  constructor(private sendSmsService: SendSmsService, private notification: NotificationService) { }

  ngOnInit() {
    this.sendSmsForm = new UntypedFormGroup({
      'recipient': new UntypedFormControl('', [Validators.required]),
      'message': new UntypedFormControl('', [Validators.required])
    });
  }

  sendSms() {
    if (this.sendSmsForm.valid) {
      this.loading = true;
      this.sendSmsService.sendSms(this.sendSmsForm.value.recipient, this.sendSmsForm.value.message,
        [
          {
            status: 400,
            message: 'sales.send-sms.errors.bad-number'
          }
        ])
      .subscribe(res => {
        this.notification.success('sales.send-sms.success');
        this.loading = false;
        this.sendSmsForm.reset();
      }, () => {
        this.loading = false;
      });
    }
  }

  getControl(name: string): AbstractControl | undefined {
    return this.sendSmsForm.get(name);
  }

  isInvalid(name: string): boolean {
    return this.sendSmsForm.get(name).invalid && this.sendSmsForm.get(name).dirty
  }
}
